






import Vue from 'vue';
import '@/assets/styles/forms.css';

export default Vue.extend({
  name: 'AuthView',
});
